import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch.tsx';

const ITEM_COUNT = 20;

const viewerFragment = graphql`
    fragment SbSharedRefineMenuFilterArtSubject_viewer on Viewer {
        ...SbSharedRefineMenuMultiSelectSearch_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterArtSubject_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectSearch_itemSearch
    }
`;

export const SbSharedRefineMenuFilterArtSubject = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    filterName,
    values,
    trackingOptions,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectSearch
            viewer={viewer}
            itemSearch={itemSearch}
            collapsedItemCount={ITEM_COUNT}
            filterName={filterName}
            values={values}
            trackingOptions={trackingOptions}
        />
    );
};

SbSharedRefineMenuFilterArtSubject.propTypes = {
    viewer: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    trackingOptions: PropTypes.object,
};
